import { useRef } from 'react';
import uniqueId from 'lodash/uniqueId';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField, {
  Props as SelectFieldProps,
} from '@wix/da-ds/pkg/Dropdown/select/SelectField/SelectField';

interface Props extends Omit<SelectFieldProps, 'id' | 'value'> {
  name: string;
  label: string;
  isRequired?: boolean;
}

function SelectInputField({ name, label = '', isRequired, onSelect, ...props }: Props) {
  const { t } = useTranslation();
  const { current: id } = useRef(uniqueId('select'));
  const { control, errors } = useFormContext();
  const error = errors[name];
  const errMsg = error?.type === 'required' ? t('sellerModal.error.required') : error?.message;

  const {
    field: { onChange: controllerOnChange, ref, ...inputProps },
  } = useController({
    name,
    control,
    rules: {
      required: isRequired,
    },
  });

  return (
    <SelectField
      {...props}
      {...inputProps}
      id={id}
      error={errors[name] ? errMsg : undefined}
      label={label}
      isRequired={isRequired}
      onSelect={(v: string, e: any) => {
        controllerOnChange(v);
        onSelect && onSelect(v, e);
      }}
    />
  );
}

export default SelectInputField;
